import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer';
import Header from '../Header';
import WhatsAppIcon from '../WhatsappIcon/WhatsAppIcon';

export default function Layout() {
  return (
    <>
      <Header logoSrc="/images/getafixmd.png" menuSrc="/images/menu-pacha.png" variant="cs_heading_color" />
      <Outlet />
      <WhatsAppIcon />
      <Footer />
    </>
  );
}
